import { format } from 'date-fns'

const FROM_KEY = 'datepicker-default-from'
const TO_KEY = 'datepicker-default-to'

export function storeDatepickerDefaults(from: Date, to: Date) {
  sessionStorage.setItem(FROM_KEY, from.toString())
  sessionStorage.setItem(TO_KEY, to.toString())
}

export function getStoredDatepickerDefaults(): { from: Date; to: Date } | null {
  const storedFrom = convertDate(sessionStorage.getItem(FROM_KEY))
  const storedTo = convertDate(sessionStorage.getItem(TO_KEY))
  if (!storedFrom || !storedTo) {
    return null
  }
  return { from: storedFrom, to: storedTo }
}

export function getDateDefaults(fallbackFrom: string, fallbackTo: string, dataAvailableTo?: Date) {
  const stored = getStoredDatepickerDefaults()
  if (!stored) {
    return { from: fallbackFrom, to: fallbackTo }
  }
  const { from: storedFrom, to: storedTo } = stored
  const shouldApplyFallback = dataAvailableTo !== undefined && dataAvailableTo < storedFrom
  if (!shouldApplyFallback) {
    return { from: format(storedFrom, 'yyyy-MM-dd'), to: format(storedTo, 'yyyy-MM-dd') }
  }

  return { from: fallbackFrom, to: fallbackTo }
}

function convertDate(date: string | null): Date | null {
  if (date) {
    return new Date(date)
  }
  return null
}
